module.exports = __webpack_public_path__ + "static/media/AhmedTaysir.e9e3e114.png";